export default __webpack_public_path__ + "static/noise-9dfebef98ee7f3944f64864f91c337b2.jpg";